import Dexie, { type EntityTable } from "dexie";
import type { Attempt, Puzzle, QueuedEvent } from "./types";

const db = new Dexie("twokings") as Dexie & {
    puzzles: EntityTable<Puzzle, "id">;
    attempts: EntityTable<Attempt, "id">;
    events: EntityTable<QueuedEvent, "id">;
};

db.version(1).stores({
    puzzles: "++id, &date",
    attempts: "++id, &puzzle_id, &session",
});

db.version(2).stores({
    puzzles: "++id, &date",
    attempts: "++id, &puzzle_id, &session",
    events: "++id, &client_event_id, session, seq, next_retry_at",
});

db.version(3).stores({
    puzzles: "++id, &date",
    attempts: "++id, &puzzle_id, &session",
    events: "++id, &client_event_id, session, [session+seq], next_retry_at",
});

export { db };
